import ManualShipmentIndex from '@/views/manual-shipments/index'
import NewManualShipment from '@/views/manual-shipments/form'

const model = 'ManualShipment'
export default [
  {
    path: '/manual_shipments',
    name: 'manualShipments',
    component: ManualShipmentIndex,
    meta: { requiresAuth: true, auth: { model, permission: 'read' } }
  },
  {
    path: '/manual_shipments/:id/upload',
    name: 'newManualShipment',
    component: NewManualShipment,
    meta: { requiresAuth: true, auth: { model, permission: 'create' } }
  }
]